import { useMemo } from 'react';

import { AnimatePresence } from 'framer-motion';

import useProductPanel from '../../../../../hooks/productpanel/useProductPanel';

import UniversalTablePagination from '../../../../Tables/universalRecord/UniversalTablePagination';

import QuotationPriceCheckItem from './QuotationPriceCheckItem';
import QuotationPriceCheckPlaceholder from './QuotationPriceCheckPlaceholder';

import ProductTableHeader from '../../../../Shared/ProductTableHeader';
import ProductTableSkeleton from '../../../../Shared/ProductTableSkeleton';

const QuotationPriceCheckListView = () => {
  const {
    filteredProducts,

    paginator,

    pageSize,

    currentFilter,

    fetchFilteredProducts,

    updateCurrentPage,

    updatePageSize,

    isLoading,
  } = useProductPanel();

  // =====================================================
  // 🔹 Products
  // =====================================================

  const products = useMemo(() => {
    return filteredProducts.filter(
      (p, index, self) =>
        index === self.findIndex((q) => q.id === p.id && q.name === p.name)
    );
  }, [filteredProducts]);

  // =====================================================
  // 🔹 Pagination
  // =====================================================

  const handlePageChange = (page: number) => {
    updateCurrentPage(page);

    fetchFilteredProducts(currentFilter || {}, page, pageSize);
  };

  const handlePageSizeChange = (size: number) => {
    updatePageSize(size);

    updateCurrentPage(0);

    fetchFilteredProducts(currentFilter || {}, 0, size);
  };

  // =====================================================
  // 🔹 Loading
  // =====================================================

  if (isLoading) {
    return <ProductTableSkeleton />;
  }

  // =====================================================
  // 🔹 Empty
  // =====================================================

  if (products.length === 0) {
    return <QuotationPriceCheckPlaceholder mode="list" />;
  }

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div className="space-y-4">
      <div
        className="
          overflow-hidden

          rounded-xl
          border

          border-stroke

          bg-white

          dark:border-strokedark
          dark:bg-boxdark
        "
      >
        <ProductTableHeader />

        <div
          className="
            divide-y
            divide-stroke

            dark:divide-strokedark
          "
        >
          <AnimatePresence mode="popLayout">
            {products.map((product) => (
              <QuotationPriceCheckItem
                key={product.id}
                product={product}
                mode="list"
              />
            ))}
          </AnimatePresence>
        </div>
      </div>

      <UniversalTablePagination
        paginator={paginator}
        data={products}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

export default QuotationPriceCheckListView;
